import "popper.js";
import "bootstrap/js/dist/util";
import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/dropdown";
import "bootstrap/js/dist/modal";
import SmoothScroll from "smooth-scroll";
import LazyLoad from "vanilla-lazyload";
import Accessibility from "./components/accessibility";
import { postsLoader } from "./components/loader";
import Menu from "./components/menu";
import Forms from "./components/forms";
import Blog from "./components/blog";
import CountryModal from "./components/country-modal";
import VideoModal from "./components/video-modal";
import {
  newsCarousel,
  relatedArticles,
  single,
  gallerySlider,
} from "./components/carousels";
import VueApps from "./vue/VueApps";

window.$ = window.jQuery;

class App {
  static init() {
    new Accessibility().init();
    new Menu().init();
    new Forms().init();
    new Blog().init();
    new CountryModal().init();
    new VideoModal().init();
    VueApps.init();

    newsCarousel();
    relatedArticles();
    single();
    gallerySlider();
    postsLoader();

    const elementsToLazyLoad = document.querySelectorAll(
      "img.lazy, div.lazy, a.lazy, span.lazy",
    );
    // eslint-disable-next-line
    const lazy = new LazyLoad({
        callback_loaded: (el) => {
          $(el).css("min-height", $(el).data("height"));
        },
      },
      elementsToLazyLoad,
    );

    $(window).on("scroll load", () => {
      const $header = $(".header");
      const $footer = $(".footer");
      const $live = $(".live_box");

      if (
        $(window).scrollTop() > $header.outerHeight() / 2 - 20 &&
        !$("body").hasClass("menu-open")
      ) {
        $header.addClass("scrolled");
      } else {
        $header.removeClass("scrolled");
      }

      if ($live.length > 0) {
        if (window.pageYOffset > $footer.offset().top - window.innerHeight) {
          $live.addClass("is_hidden");
        } else {
          $live.removeClass("is_hidden");
        }
      }
    });
    // eslint-disable-next-line
    const scroll = new SmoothScroll('a[href*="#"]', {
      header: ".header.scrolled",
    });

    $(".js-search-mobile-btn").click((e) => {
      if (document.body.classList.contains("menu-open")) {
        $(".header .navbar-toggler").trigger("click");
      }
      e.preventDefault();
      $(document.body).toggleClass("search-open");
    });

    $(".navbar-toggler").click(() => {
      $(document.body).removeClass("search-open");
    });

    $(".wysiwyg p:empty").remove();

    $(".collapse").on("show.bs.collapse", function show() {
      $(this).parent().addClass("active");
    });

    $(".collapse").on("hide.bs.collapse", function hide() {
      $(this).parent().removeClass("active");
    });
  }
}

App.init();
